import { BaseConnector } from './baseConnector';

class KleHierarchyConnector extends BaseConnector {
  getKleHierarchies() {
    var url = `${this.baseApiUrl}/kleHierarchy`;
    return this.authFetch(url);
  }
}

export { KleHierarchyConnector };
